import React from 'react'
import { Router } from '@reach/router'
import Appbar from 'components/Appbar'
import useLeases from './hooks/useLeases'
import { useTrackNavigate } from '@hooks'
import { ModalLayer } from '@ui'
import Search from './Search'
import TableView from './TableView'
import { NavigateFn } from '@reach/router'
import { navigateWithBasepath } from '../../App'
import { PageContent } from '@ui'

export default function LeaseManagement({ navigate }: { navigate?: NavigateFn }) {
  //Tracks page load
  useTrackNavigate()
  const leases = useLeases()
  return (
    <>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigateWithBasepath}>
        <ModalLayer path="*" reload={leases.reload} />
      </Router>
      <Appbar title="Leases">
        <Search {...{ navigate, queryTable: leases.queryTable }} />
      </Appbar>
      <PageContent>
        <TableView {...{ leases, navigate }} />
      </PageContent>
    </>
  )
}
